export default "__VITE_ASSET__XdhqNH5X__"